import { AllocationWeightedShareValue } from 'common/types/valuation';
import { getArrayValue } from 'utilities';

const hasRangeSensitivityFundRow = (weightedShareValue?: AllocationWeightedShareValue) =>
  weightedShareValue?.fund?.id != null && getArrayValue(weightedShareValue.share_values).length > 0;

export const getRangeSensitivityFundRows = (weightedShareValues?: AllocationWeightedShareValue[]) =>
  getArrayValue(weightedShareValues).filter(hasRangeSensitivityFundRow);
